import React, { useEffect, useRef } from "react";

import { string, array, arrayOf, shape } from "prop-types";

import initAccordion from "../../../common/initAccordions.js";

import Accordion from "../../Accordion/Accordion.jsx";

const propTypes = {
  title: string,
  sectors: array,
  description: string,
  bodyContent: arrayOf(
    shape({ accordionTitle: string, accordionText: string }),
  ),
  buttonLink: shape({ text: string, href: string }),
};

const BackOfCard = (props) => {
  const { sectors, title, description, bodyContent, buttonLink } = props;

  const containerRef = useRef();

  // Init Accordions
  useEffect(() => {
    if (bodyContent) {
      [...containerRef.current.querySelectorAll(".js-accordion")].forEach(
        (el) => {
          initAccordion(el);
        },
      );
    }
  }, [bodyContent]);

  return (
    <div ref={containerRef} className="slider-card__container container">
      {sectors && (
        <div className="slider-card__tag-container">
          {sectors.map((sector) => (
            <span key={sector} className="slider-card__tag">
              {sector}
            </span>
          ))}
        </div>
      )}
      {title && <h3 className="slider-card__title">{title}</h3>}
      {description && (
        <div
          className="slider-card__description"
          dangerouslySetInnerHTML={{ __html: description }}
        />
      )}
      <div className="slider-card__content-back-side">
        {bodyContent?.map((c, idx) => (
          <Accordion key={idx} title={c?.accordionTitle}>
            <div
              dangerouslySetInnerHTML={{
                __html: c?.accordionText,
              }}
            ></div>
          </Accordion>
        ))}
        {buttonLink && (
          <a href={buttonLink?.href} className="btn btn--secondary">
            {buttonLink?.text}
          </a>
        )}
      </div>
    </div>
  );
};

BackOfCard.propTypes = propTypes;

export default BackOfCard;
